import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import CEECampaignsContext from "context/CEECampaignsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import AddCase from "./AddCase";
import UserService from "services/UserService";
import axios from "axios";
import { getCEECampaignMembershipCases } from "services/ConfigServices";
import {
  ceecaseStatusData,
} from "variables/lists/cee";
import { ceecase } from "variables/cee";
import moment from "moment";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useCasesTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const cee_admin = permis.includes("cee_admin");
  const cee_update = permis.includes("cee_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign, setCeecampaign } = ceeCampaignContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getCEECampaignMembershipCases(chartIdGroup, ceecampaign.id);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedCases, setSelectedCases] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `cases`, []).filter(
    (item) =>
      (item.parameters.name && item.parameters.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.ceeform && item.parameters.ceeform.toLowerCase().includes(filterText.toLowerCase())) ||      
      (item.parameters.ceecampaignmembershipname && item.parameters.ceecampaignmembershipname.toLowerCase().includes(filterText.toLowerCase())) ||      
      (item.parameters.description && item.parameters.description.toLowerCase().includes(filterText.toLowerCase())) ||      
      (item.parameters.referentname && item.parameters.referentname.toLowerCase().includes(filterText.toLowerCase())) ||   
      (item.parameters.referentemail && item.parameters.referentemail.toLowerCase().includes(filterText.toLowerCase())) ||  
      (item.parameters.referentphone && item.parameters.referentphone.toLowerCase().includes(filterText.toLowerCase())) ||  
      (item.parameters.comments && item.parameters.comments.toLowerCase().includes(filterText.toLowerCase())) ||     
      (item.parameters.status && ceecaseStatusData.find((x) => x.id == item.parameters.status) && ceecaseStatusData.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.author && item.parameters.author.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.validationdate && moment(item.parameters.validationdate).isValid() && moment(item.parameters.validationdate).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.enddate && moment(item.parameters.enddate).isValid() && moment(item.parameters.enddate).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.creationdate && moment(item.parameters.creationdate).isValid() && moment(item.parameters.creationdate).format("DD/MM/YYYY hh:mm").includes(filterText))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedCases.map((item) => {
      let casetoexport = {};
      casetoexport[ceecase.groups] = (item.parameters.groups && groupInfoListById["" + item.parameters.groups]) ? groupInfoListById["" + item.parameters.groups] : "";
      casetoexport[ceecase.creationdate] = (item.parameters.creationdate && moment(item.parameters.creationdate).isValid()) ? moment(item.parameters.creationdate).format("DD/MM/YYYY HH:mm") : "";
      casetoexport[ceecase.status] = ceecaseStatusData.find((x) => x.id == item.parameters.status)?.name;
      casetoexport[ceecase.validationdate] = (item.parameters.validationdate && moment(item.parameters.validationdate).isValid()) ? moment(item.parameters.validationdate).format("DD/MM/YYYY") : "";
      casetoexport[ceecase.ceeform] = item.parameters.ceeform;
      casetoexport[ceecase.name] = item.parameters.name;
      casetoexport[ceecase.referentname] = item.parameters.referentname;
      casetoexport[ceecase.referentemail] = item.parameters.referentemail;
      casetoexport[ceecase.referentphone] = item.parameters.referentphone;
      casetoexport[ceecase.author] = item.parameters.author;
      casetoexport[ceecase.comments] = item.parameters.comments;
     return casetoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {cee_update && (
          <UploadButton type="button" onClick={handleClear}>
            <AddCase refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedCases || selectedCases.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedCases]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedCases
  };
}
